/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateMerchantCapabilitiesRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateMerchantCapabilitiesResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateMerchantCapabilities = (request: UpdateMerchantCapabilitiesRequest, options?: CashRequestOptions) => post<UpdateMerchantCapabilitiesRequest, UpdateMerchantCapabilitiesResponse>("/2.0/cash/update-merchant-capabilities", request, {...options, rejectOnError: true })